import { AppDomain, Config } from '@browsing/config';
import { screenSizes } from '@lux/core';

export const getSupportedLanguages = (config: Config) => {
    const appdomains = config.getSwitchUrlAppdomains();
    if (!appdomains) {
        return null;
    }

    const { pathname = '', search = '', hash = '' } = window.location;

    return Object.keys(appdomains).map(appdomainId => ({
        countryCode: config.getCountryCodeForAppdomainId(appdomainId).toUpperCase(),
        url: `//${appdomains[appdomainId as unknown as AppDomain]}${pathname}${search}${hash}`,
        active: String(config.appdomain) === appdomainId,
    }));
};

export const getCredentialsStatus = (hasCompromised: boolean, customerAcrValue: string) => {
    const isAcrSessionStatusUnknown = customerAcrValue === 'acr unavailable' && !hasCompromised;
    if (hasCompromised) {
        return 'compromised';
    }
    if (isAcrSessionStatusUnknown || !customerAcrValue) {
        return 'unknown';
    }
    if (
        !hasCompromised &&
        customerAcrValue.includes('https://customer-sso.docs.zalando.net/policies/')
    ) {
        const acrSuffix = customerAcrValue.replace(
            'https://customer-sso.docs.zalando.net/policies/',
            '',
        );
        return `not_compromised_${acrSuffix}`;
    }
};

export const getTopPosition = (
    showUSPVisibility: boolean,
    isBannerShouldBeRemovedInDom: boolean,
    isBannerShown: boolean,
    bannerHeight: number = 60,
) => {
    if (!showUSPVisibility) {
        return isBannerShouldBeRemovedInDom || isBannerShown ? 0 : -bannerHeight;
    }
    if (isBannerShouldBeRemovedInDom) {
        return -32;
    }
    return isBannerShown ? 0 : -92;
};

export const isMobileOrTablet = () => {
    if (typeof window !== 'undefined') {
        return window.matchMedia(`(max-width: ${screenSizes.md}px)`).matches;
    }
    return false;
};
